import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'routeTicket',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        update_route_ticket: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_route_ticket_auto_price: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_route_ticket_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        switch_auto_price: (state) => {
            return {
                ...state,
            };
        },
        update_route_ticket_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
    }
});

export const { reducer, actions } = slice;

export default reducer;